import AppDashboardIcon from '../icons/AppDashboardIcon';
import AppInfoIcon from '../icons/AppInfoIcon';
import AppMediaIcon from '../icons/AppMediaIcon';
import AppProductsIcon from '../icons/AppProductsIcon';
import AppReleasesIcon from '../icons/AppReleasesIcon';
import AppReviewsIcon from '../icons/AppReviewsIcon';
import AppStatsIcon from '../icons/AppStatsIcon';
import AppTransactionsIcon from '../icons/AppTransactionsIcon';
import LoginWithBazaarIcon from '../icons/LoginWithBazaarIcon';
import AppPishkhanApiIcon from '../icons/AppPishkhanApiIcon';
import AppSalesIcon from '../icons/AppSalesIcon.vue';
import AppSupportIcon from '../icons/AppSupportIcon.vue';


export default ({
  hasStatistics,
  hasChangeAppInfo,
  hasDevelopment,
  hasFinance,
  hasSupport,
  hasOAuth,
  esraNeedsRequest,
  alphaEnabled,
  betaEnabled,
}) => ({
  key: 'app-sidebar',
  backButton: {
    route: 'apps',
    title: 'APPLICATIONS',
  },
  items: [
    {
      route: 'app-dashboard',
      title: 'APPS.DASHBOARD.TITLE',
      icon: AppDashboardIcon,
      enabled: hasStatistics,
    },
    {
      route: 'app-info',
      title: 'APPS.INFO.TITLE',
      icon: AppInfoIcon,
      enabled: hasChangeAppInfo,
      warnBadge: esraNeedsRequest,
    },
    {
      route: 'app-media',
      title: 'APP.MEDIA.TITLE',
      icon: AppMediaIcon,
      enabled: hasChangeAppInfo,
    },
    alphaEnabled || betaEnabled
      ? {
          route: 'app-releases',
          title: 'APP.RELEASES.TITLE',
          icon: AppReleasesIcon,
          enabled: hasDevelopment,
          children: [
            {
              route: 'app-releases-management',
              title: 'APP.RELEASES.MANAGEMENT',
            },
            {
              route: 'app-releases-group',
              title: 'APPS.RELEASES..RELEASE_GROUP',
            },
          ],
        }
      : {
          route: 'app-releases',
          title: 'APP.RELEASES.TITLE',
          icon: AppMediaIcon,
          enabled: hasChangeAppInfo,
        },
    {
      route: 'transactions',
      title: 'APP.TRANSACTIONS.TITLE',
      icon: AppTransactionsIcon,
      enabled: hasFinance,
      children: [
        {
          route: 'transactions-purchases',
          title: 'APP.TRANSACTIONS.PURCHASES',
        },
        {
          route: 'transactions-sub-purchases',
          title: 'APP.TRANSACTIONS.SUB-PURCHASES',
        },
      ],
    },
    {
      route: 'in-app-purchases',
      title: 'APP.IAB.TITLE',
      icon: AppProductsIcon,
      enabled: hasDevelopment,
      children: [
        {
          route: 'in-app-purchases-products',
          title: 'APP.IAB.PRODUCTS_TITLE',
        },
        {
          route: 'in-app-purchases-settings',
          title: 'SETTINGS',
        },
      ],
    },
    {
      route: 'app-reviews',
      title: 'APP.REVIEWS.TITLE',
      icon: AppReviewsIcon,
      enabled: hasSupport,
    },
    {
      route: 'app-tickets',
      title: 'APPS.SUPPORT.TITLE',
      icon: AppSupportIcon,
      enabled: hasSupport,
    },
    {
      route: 'stats-builder',
      title: 'APP.STATS_BUILDER.TITLE',
      icon: AppStatsIcon,
      enabled: hasStatistics,
    },
    {
      route: 'oauth',
      title: 'APP.OAUTH.TITLE',
      icon: LoginWithBazaarIcon,
      enabled: hasOAuth,
    },
    {
      route: 'sales-report',
      title: 'APP.SALES_REPORT.TITLE',
      icon: AppSalesIcon,
      enabled: hasFinance,
    },
    {
      route: 'app-api-agents',
      title: 'APP.API_AGENTS.TITLE',
      icon: AppPishkhanApiIcon,
      enabled: hasDevelopment,
    },
  ],
});
